<template>
  <div v-click-outside="onClickOutside" id="box--sort">
    <span class="submenu--item" @click="opensort()">
      Sorted By
      <font-awesome-icon class="submenu--icon" icon="chevron-down" />
    </span>
    <div class="box--sort">
      <div class="box--sort--triangulo"></div>
      <span class="box--item" id="imdb" @click="selectSort('imdb')"
        ><font-awesome-icon class="box--icon" icon="check" /> Popularity</span
      >
      <span
        class="box--item"
        id="releaseYear"
        @click="selectSort('releaseYear')"
        ><font-awesome-icon class="box--icon" icon="check" /> Release Year</span
      >
      <span class="box--item" id="abc" @click="selectSort('abc')"
        ><font-awesome-icon class="box--icon" icon="check" /> Alphabetical</span
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    items: [],
    sort: []
  }),
  computed: mapState(["generalsort"]),

  mounted() {
    this.$store.commit("EDIT_SORT", "");

    // let params = {
    //   data: '',
    //   src: this.$route.name
    // };
    // this.$store.dispatch("FETCH_EDIT_SORT", params);
  },
  methods: {
    onClickOutside() {
      let el = document.getElementsByClassName("box--sort");
      el[0].classList.remove("menu-visible");
    },

    opensort() {
      let el = document.getElementsByClassName("box--sort");
      el[0].classList.toggle("menu-visible");
    },

    selectSort(i) {
      let item = document.getElementsByClassName("box--item");
      item.forEach(element => {
        let icon = element.children[0];
        element.classList.remove("sort-active");
        icon.classList.remove("sort-active-icon");
      });

      let select = document.getElementById(i);
      let icon = select.children[0];
      select.classList.toggle("sort-active");
      icon.classList.toggle("sort-active-icon");

      let params = {
        data: i,
        src: this.$route.name
      };
      this.$store.dispatch("FETCH_EDIT_SORT", params);
      this.onClickOutside();
    }
  }
};
</script>

<style scoped>
.box--sort {
  background-color: #1c2531;
  display: grid;
  grid-template-columns: auto;
  column-gap: 25px;
  color: #d5d5d5;
  font-size: 0.8em;
  padding: 4px 20px 15px 20px;
  position: absolute;
  z-index: 1000;
  margin-top: 6px;
  margin-left: -40px;
  visibility: hidden;
}
.submenu--item {
  color: #d5d5d5;
  font-size: 15px;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  border: 1px solid #738092;
  border-radius: 5px 5px 5px 5px;
  padding: 5px 10px;
  margin-bottom: -1px;
}
.submenu--icon {
  font-weight: thin;
  padding-left: 10px;
  align-self: end;
}

.box--sort--triangulo {
  position: absolute;
  width: 20px;
  height: 10px;
  top: -6px;
  right: 5px;
  background: #1c2531;

  /* The points are: centered top, left bottom, right bottom */
  clip-path: polygon(50% 0, 0 100%, 100% 100%);
}

.box--title {
  color: white;
  font-size: 1.3em;
  padding-bottom: 10px;
}
.box--reset {
  align-self: top;
  justify-self: end;
  cursor: pointer;
}

.box--item {
  padding: 5px;
  margin: 2px;
  cursor: pointer;
}

.box--icon {
  padding-right: 5px;
}

.sort-active {
  color: white;
  font-weight: 600;
  border: 1px solid #738092;
  border-radius: 7px;
}
.sort-active-icon {
  color: #94c659;
}
.menu-visible {
  visibility: visible;
}

@media (min-width: 600px) and (max-width: 960px) {
  .submenu--item {
    font-size: 0.75em;
  }
  .menu--item-select {
    align-self: end;
    column-gap: 0px;
  }
}
@media (max-width: 600px) {
  .submenu--item {
    font-size: 0.5em;
  }
  .box--item {
    font-size: 0.7em;
  }
  .box--sort {
    padding: 4px 10px 15px 10px;
  }
}
</style>
